import { Spinner } from '@xometry/xometry_loft';
import React, { FC, Suspense } from 'react';
import { ModalType } from '../../Component';
import { WWW_ORIGIN } from '../../config';
import { lazyWithRetries } from '../../utils/shimport';

interface Props {
  activeUserId: string;
  openModal: ModalType | null;
  setOpenModal: (modal: ModalType | null) => void;
}

const NewQuoteURLModal = `${WWW_ORIGIN}/quoting/quote/microcomponents/new-quote-modal.mjs`;
const LazyNewQuoteModal = lazyWithRetries(NewQuoteURLModal);

export const NewQuoteModal: FC<Props> = (props: Props) => {
  const { openModal, setOpenModal, activeUserId } = props;
  return (
    <>
      <Suspense fallback={<Spinner />}>
        <LazyNewQuoteModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          activeUserId={activeUserId}
        />
      </Suspense>
    </>
  );
};
